import React, {Component, PropTypes} from "react";
import { Modal } from 'react-bootstrap';
import { connectReduxForm } from 'redux-form';
import { validateCompleteRegistration } from 'utils/validateNormalize';
import Regionalization from "services/regionalization"
import {
  GetCity,
  GetStatesOrProvince,
  GetCountry,
  GetSchool
} from "../auth/registrationComponents";

@connectReduxForm({
  form: 'completeRegistration',
  fields: [
    'alert',
    'country',
    'cityOrMunicipality',
    'stateOrProvince',
    'school'
  ],
  validate: validateCompleteRegistration
})
export default class CompleteRegistrationModal extends Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    fields: PropTypes.shape({
      alert: PropTypes.object.isRequired,
      country: PropTypes.object.isRequired,
      cityOrMunicipality: PropTypes.object.isRequired,
      stateOrProvince: PropTypes.object.isRequired,
      school: PropTypes.object.isRequired
    }).isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.countries = Regionalization.getCountries();
  }

  handleSubmit(evt) {
    this.props.handleSubmit(evt);
  }

  handleCountryChange(evt) {
    const {country, stateOrProvince} = this.props.fields;
    country.onChange(evt);
    const statesOrProvinces = Regionalization.getStatesOrProvinces(evt.target.value);
    if (statesOrProvinces.length === 1) {
      stateOrProvince.onChange(statesOrProvinces[0].code);
    } else {
      stateOrProvince.onChange('');
    }
  }

  render() {
    const {showModal, closeModal, fields, invalid} = this.props;
    const {country, stateOrProvince, cityOrMunicipality, school} = fields;

    const statesOrProvinces = Regionalization.getStatesOrProvinces(country.value);
    if (statesOrProvinces.length === 1) {
      stateOrProvince.disabled = true;
    }

    return (
      <Modal backdrop="static" show={showModal} onHide={closeModal} keyboard={false} dialogClassName="complete-registration-modal">
        <Modal.Header>
          <Modal.Title>
            About your school
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Tell us about your school so we can tailor to your region!</h4>
          <hr />
          <label className="control-label" style={{float: "right"}}>* Required Fields</label>
          <GetCountry country={({...country, onChange: this.handleCountryChange.bind(this)})} countries={this.countries} />
          <GetStatesOrProvince stateOrProvince={stateOrProvince} statesOrProvinces={statesOrProvinces} />
          <GetCity cityOrMunicipality={cityOrMunicipality} />
          <GetSchool school={school} />
        </Modal.Body>
        <Modal.Footer>
          <button disabled={invalid?'disabled':''}
                  onClick={::this.handleSubmit}
                  className="btn btn-lg btn-primary">
            Next
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/completeRegistrationModal.jsx